import { Box } from '@material-ui/core';
import { Channel } from '@nemuru-eng/js-api-client';

import { ChannelTypeOptions } from '@/components/modules/ChannelDetail/ChannelDetails/constants/ChannelTypeOptions';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';

interface ConfigurationFormProps extends FormGridOptions {
  currentChannel: Channel;
}

export const ConfigurationForm = ({ currentChannel, fullWidth, fieldVariant }: ConfigurationFormProps) => {
  return (
    <Box pt={2}>
      <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth}>
        <TextFormField label={'CHANNEL_DESCRIPTION'} value={currentChannel.description} name={'description'} />
        <SelectFormField
          label={'CHANNEL_TYPE'}
          value={currentChannel.type}
          name={'type'}
          selectOptions={ChannelTypeOptions}
        />
      </FormGridContainer>
    </Box>
  );
};
